document.addEventListener("DOMContentLoaded", function () {

	if (window.innerWidth > 767 && document.getElementsByClassName('vimeo-video-loaded').length < 1) {
	console.log("Loading videos");
	createVimeoHero();
}
	else {
	console.log("Using mobile viewport or vimeo videos already loaded");
}
});

window.addEventListener("resize", resizeHandler);

function resizeHandler() {
	console.log("Resized to " + window.innerWidth);
	var vwrappers = document.getElementsByClassName('vimeo-wrapper');
	if (vwrappers.length > 0 && window.innerWidth > 767) {
		console.log("Viewport larger than mobile threshold. Loading videos");
		createVimeoHero();
	}
}

function createVimeoHero() {
	var vwrappers = document.getElementsByClassName('vimeo-wrapper');
	if (vwrappers.length > 0) {
		for (const vwrapper of vwrappers) {
			const vimeoId = vwrapper.dataset.vimeoId
			if (vimeoId !== null && vimeoId !== "") {
				var iframe = document.createElement('iframe');
				iframe.src = "https://player.vimeo.com/video/" + vimeoId + "?background=1";
				iframe.style.width = "";
				iframe.style.height = "";
				iframe.frameborder = "0";
				vwrapper.appendChild(iframe);
				vwrapper.classList.add('vimeo-video-loaded');
			}
		}
	}

	//remove resize event listener
	window.removeEventListener("resize", resizeHandler);
}